import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: '3rem 6rem 2rem',
      minHeight: 0,
      height: '100%',
    },
  }),
)
